import { useSyncExternalStore } from 'react';

type States = {
    hashes: {
        [key: string]: string;
    };
};

type Reducers = {
    setHash: (key: string, val: string) => void;
    getHash: (key: string) => string;
};

const initialState: States = {
    hashes: {}
};

let internalState: States = { ...initialState };
const listeners = new Set<() => void>();

function notify() {
    for (const l of Array.from(listeners)) l();
}

function setHash(key: string, val: string) {
    internalState = { hashes: { ...internalState.hashes, [key]: val } };
    notify();
}

function getHash(key: string) {
    return internalState.hashes?.[key] || '';
}

export const hasherStore = {
    getState: () => ({ ...internalState }),
    subscribe(listener: () => void) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
    setHash,
    getHash,
};

export default function useHasher<T = States & Reducers>(selector?: (s: States & Reducers) => T) {
    const subscribe = (cb: () => void) => {
        listeners.add(cb);
        return () => listeners.delete(cb);
    };

    const getSnapshot = () => (selector ? selector({ ...hasherStore.getState(), setHash, getHash } as States & Reducers) : ({ ...hasherStore.getState(), setHash, getHash } as unknown as T));

    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

